/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import Aos from "aos";
import 'aos/dist/aos.css';
import Guides from '../components/aboutPieria/Guides';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px 100px;

  @media (max-width: 768px) { margin: 20px 80px; }
  @media (max-width: 480px) { margin: 20px 50px; }
`;

const Title = styled.div`
  font-size: 40px;
  color: #385963;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;

  @media (max-width: 768px) { font-size: 25px; }
  @media (max-width: 480px) { font-size: 18px; }
`;

const Description = styled.div`
  font-size: 18px;
  color: #91abb3;
  margin: 50px 100px 100px;
  text-align: center;

  @media (max-width: 768px) { font-size: 14px; margin: 10px 20px 80px; }
  @media (max-width: 480px) { font-size: 10px; margin: 10px 10px 50px; }
`;

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 90%;
  aspect-ratio: 16 / 9;
  margin: 0 auto 50px;
  border-radius: 10px;
  overflow: hidden;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const DownloadPDF = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Message = styled.div`
  font-size: 16px;
  color: #385963;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;

  @media (max-width: 768px) { font-size: 12px; }
  @media (max-width: 480px) { font-size: 8px; }
`;

const DownloadContainer = styled.div`
  margin-top: 50px ;
  margin-bottom:100px;
  display:flex;
  flex-direction:column;
  align-items:center;
  gap: 50px;
  text-align:center;

  @media (max-width: 768px) {
    gap: 40px;
    margin-top: 40px ;
    margin-bottom:800px;
    text-align:center;
  }
`;

const AboutPieria = () => {
  const { i18n, t } = useTranslation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = sessionStorage.getItem("token");
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';

  const emptyField = { en: '', gr: '' };
  const [pieriaInfo, setPieriaInfo] = useState({
    description1: { ...emptyField },
    description2: { ...emptyField },
    link: '',
    stat1: { label: { ...emptyField }, number: '' },
    stat2: { label: { ...emptyField }, number: '' },
    stat3: { label: { ...emptyField }, number: '' },
    stat4: { label: { ...emptyField }, number: '' },
  });

  useEffect(() => {
    Aos.init({ duration: 1000 });

    const fetchPieriaInfo = async () => {
      try {
        const res = await fetch(`${BASE_URL}PieriaInfo`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (!res.ok) {
          console.warn('Failed to fetch Pieria info:', res.status);
          return;
        }

        const data = await res.json();
        if (data && data.length > 0) {
          const info = data[0];
          setPieriaInfo({
            description1: info.description1 || { ...emptyField },
            description2: info.description2 || { ...emptyField },
            link: info.link || '',
            stat1: info.stat1 || { label: { ...emptyField }, number: '' },
            stat2: info.stat2 || { label: { ...emptyField }, number: '' },
            stat3: info.stat3 || { label: { ...emptyField }, number: '' },
            stat4: info.stat4 || { label: { ...emptyField }, number: '' },
          });
        }
      } catch (err) {
        console.error('Fetch error:', err);
      }
    };

    fetchPieriaInfo();
  }, [BASE_URL, token]);

  const renderText = (field) => {
    if (!field) return t('noDataAvailable');
    return selectedLanguage === 'gr' ? field.gr || t('noDataAvailable') : field.en || t('noDataAvailable');
  };


  return (
    <Container>
      <Title data-aos="zoom-in">{t('aboutPieria')}</Title>

      {/* Description 2 */}
      <Description data-aos="zoom-in-down" style={{ whiteSpace: "pre-line" }}>
        {renderText(pieriaInfo.description2)}
      </Description>

      {/* Video */}
      <VideoWrapper>
        <iframe
          src={selectedLanguage === 'gr'
                ? "https://www.youtube.com/embed/MV2gVHLGFOo?si=2f4ZQLjwNtY9L_Lb"
                : "https://www.youtube.com/embed/TezkrPd6sOg?si=xUJpbgwwN_mt4nA9"}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </VideoWrapper>

      <DownloadPDF>
    
        <DownloadContainer>
          <Title >Document Library</Title>
          <Guides />
        </DownloadContainer>
      </DownloadPDF>
    </Container>
  );
};

export default AboutPieria;
